import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Debug logging for environment detection
console.log('🔍 Proof Service Environment Debug:');
console.log('REACT_APP_VERFI_ENV:', process.env.REACT_APP_VERFI_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('REACT_APP_PROOF_URL:', process.env.REACT_APP_PROOF_URL);

// Test environment functions
try {
  import('./lib/environment').then(({ detectEnvironment, getApiUrl, getProofUrl }) => {
    console.log('🧪 Environment function test:');
    console.log('- detectEnvironment():', detectEnvironment());
    console.log('- getApiUrl():', getApiUrl());
    console.log('- getProofUrl():', getProofUrl());
  }).catch(error => {
    console.error('❌ Environment function test failed:', error);
  });
} catch (error) {
  console.error('❌ Environment import failed:', error);
}

// Environment-aware basename using standardized detection
const getBasename = () => {
  try {
    // Use synchronous environment variable check since we're in browser context
    const env = process.env.REACT_APP_VERFI_ENV;
    
    // Production uses no prefix, all other environments use /proof prefix
    if (env === 'production') {
      return '';
    }
    return '/proof';
  } catch (error) {
    console.error('Error determining basename:', error);
    return '/proof'; // Safe fallback
  }
};

const basename = getBasename();
console.log('🛣️ Using basename:', basename);
console.log('🌐 Current URL:', window.location.href);
console.log('🗂️ Current pathname:', window.location.pathname);
console.log('🏠 Hostname:', window.location.hostname);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
